import React from 'react';
import Buttons from '../Common/Buttons';
import { useLocale } from '../../localization/LocaleContext';


export default function TryInvoice(){
    const { t } = useLocale();

    return(
        <section className="tryInvoice h-450 flex-center-align flex-column">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 offset-lg-3 flex-center-align flex-column">
                        <h1 className="h-1 fs-50 h-bold mb-10 text-center">
                            {t('shared.tryInvoiceTitle')}
                        </h1>
                    <p className="paragraph p-adjustment pb-50 mb-0 m-center">{t('shared.tryInvoiceSubtitle')}</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-3"></div>
                    <div className="col-lg-6 flex-justify-center display-flex">
                        <Buttons/>
                    </div>
                    <div className="col-lg-3"></div>
                </div>
            </div>
        </section>
    )
}